import { render, staticRenderFns } from "./CompletedServiceRequest.vue?vue&type=template&id=0c479ece&scoped=true&"
import script from "./CompletedServiceRequest.vue?vue&type=script&lang=js&"
export * from "./CompletedServiceRequest.vue?vue&type=script&lang=js&"
import style0 from "./CompletedServiceRequest.vue?vue&type=style&index=0&id=0c479ece&prod&lang=scss&scoped=true&"
import style1 from "./CompletedServiceRequest.vue?vue&type=style&index=1&id=0c479ece&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c479ece",
  null
  
)

export default component.exports